/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React from 'react'
import { useState, useEffect } from 'react';
import { withRouter, useParams } from "react-router-dom";
import { Grid } from 'react-bootstrap';
import * as API from 'Front/api/emr';
import moment from 'moment';

const EmrSummary = ({ row, handleLoading }) => {

    const [visitList, setvisitList] = useState([]);
    const [patientSymtomsData, setPatientSymtomsData] = useState([]);
    const [patientPrescriptionData, setPatientPrescriptionData] = useState([]);
    const [longTermData, setLongTermData] = useState([]);
    const [intercurrentData, setIntercurrentData] = useState([])
    const [alertMsg, setAlertMsg] = useState(null);
    const [appointment, setAappointment] = useState();
    const [lengthForIndex, setLengthForIndex] = useState('');
    let patientId = row?._id;



    const getAllVisits = async () => {
        let id = patientId;
        let resp = await API.getAllVisitList({ patientId: id });
        setvisitList([...resp.data.allVisits])
        setAappointment(resp.data.allVisits[0]._id)
        selectDateHistory(resp.data.allVisits[0]._id, resp.data.allVisits[0].patientId);
    }
    const selectDateHistory = async (appId, pId) => {
        setAappointment(appId);
        let res = await API.patientHistory({ appointmentId: appId, patientId: pId });
        setPatientSymtomsData([...res.data.patientSymtomsData]);
        setPatientPrescriptionData([...res.data.patientPrescriptionData]);
        setLongTermData([...res.data.longTermData]);
        setLengthForIndex(res.data.longTermData.length);
        setIntercurrentData([...res.data.intercurrentData]);
    }
    const doseTimeForPrescription = (data) => {
        let name = [];
        for (let i in data) {
            name.push(data[i].doseTimeSlotName);
        }
        return name.join(" , ");
    }
    const instructionNameForPrescription = (data) => {
        let name = [];
        for (let i in data) {
            name.push(data[i].instructionName);
        }
        return name.join(' , ');
    }
    useEffect(() => {
        getAllVisits();
    }, []);

    return (

        <div className="main-content emr-wrapper dashboard-2-0" style={{ padding: '15px 0px' }}>
            <span > {alertMsg}</span>
            <Grid fluid>
                <div className="card-content-inner">
                    <div className="emr-menu-list">
                        <ul>
                            {visitList.map((item, index) =>
                                <li onClick={e => selectDateHistory(item._id, item.patientId)} className={item._id === appointment ? "current" : ""}><a>{moment(item.createdAt).format('DD MMM YYYY')}</a></li>
                            )}
                        </ul>
                    </div>
                    <div className="history-wrapper">
                        {patientSymtomsData && patientSymtomsData.length > 0 &&
                            <div className="history-col history-col-half" >

                                <h5>Complaints</h5>
                                <div id="divComplaints" className="center-content-table table-responsive-new">
                                    <table class="table table-bordered visit-table complaints-table-style">
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{ textAlign: 'center' }}>#</th>
                                                <th scope="col">Complaints</th>
                                                <th scope="col" style={{ textAlign: 'center' }}>Duration</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {patientSymtomsData.map((complaint, index) => (
                                                <tr id="addr0">
                                                    <th scope="row" style={{ textAlign: 'center' }}>{index + 1}</th>
                                                    <td>{complaint.symptomsSubCategoryName}</td>
                                                    <td>{complaint.duration.no} {complaint.duration.period}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>}
                        {(longTermData.length > 0 || intercurrentData.length > 0) &&
                            <div className="history-col history-col-half" >
                                <h5>Diagnosis</h5>
                                <div className="center-content-table table-responsive-new">
                                    <table class="table table-bordered visit-table complaints-table-style">
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{ textAlign: 'center', minWidth: '40px' }}>#</th>
                                                <th scope="col" style={{ minWidth: '120px' }}>Diagnosis</th>
                                                <th scope="col" style={{ minWidth: '60px' }}>Type</th>
                                                <th scope="col" style={{ minWidth: '100px' }}>Added Date</th>
                                                <th scope="col" style={{ minWidth: '80px' }}>Duration</th>
                                                {/* <th scope="col">Completed</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {longTermData.map((data, index) => (
                                                <tr >
                                                    <td scope="row" style={{ textAlign: 'center', minWidth: '40px' }}>{index + 1}</td>
                                                    <td style={{ minWidth: '120px' }}>{data.diagonsisSubCategoryName}</td>
                                                    <td style={{ minWidth: '60px' }}>LT</td>
                                                    <td style={{ minWidth: '100px' }}>{moment(data.createdAt).format('DD MMM YYYY')}</td>
                                                    <td style={{ minWidth: '80px' }}>{data.duration.no} {data.duration.period}</td>
                                                    {/* <td>Yes</td> */}
                                                </tr>
                                            ))}
                                            {intercurrentData.map((data, index) => (
                                                <tr >
                                                    <td scope="row" style={{ textAlign: 'center' }}>{lengthForIndex + index + 1}</td>
                                                    <td>{data.diagonsisSubCategoryName}</td>
                                                    <td>IC</td>
                                                    <td>{moment(data.createdAt).format('DD MMM YYYY')}</td>
                                                    <td>{data.duration.no} {data.duration.period}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                        {patientPrescriptionData.length > 0 &&
                            <div className="history-col history-col-full" >
                                <h5>Prescription</h5>
                                <div className="center-content-table table-responsive-new">
                                    <table class="table table-bordered complaints-table-style visit-table">
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{ textAlign: 'center', minWidth: '40px' }}>#</th>
                                                <th scope="col">Brand name</th>
                                                <th scope="col">Dose Time</th>
                                                <th scope="col">Duration</th>
                                                <th scope="col">Instruction</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {patientPrescriptionData.map((data, index) => (
                                                <tr  >
                                                    <td scope="row" style={{ textAlign: 'center', minWidth: '40px' }}>{index + 1}</td>
                                                    <td>{data.drugNameWithDose}</td>

                                                    <td>{doseTimeForPrescription(data.doseTimeSlot)}</td>

                                                    <td>{data.duration.no} {data.duration.period}</td>
                                                    <td>{instructionNameForPrescription(data.instructionName)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>}

                    </div>
                    {patientPrescriptionData.length == 0 && patientSymtomsData.length == 0 && intercurrentData.length == 0 &&
                        <div style={{ color: "black", marginTop: "100px", textAlign: "center" }}><h6>No data found!</h6></div>
                    }
                </div>
            </Grid >
        </div >


    )
}

export default withRouter(EmrSummary);
